import { fetchApi } from '../../../utils/fetchHelper';
import endpoints from './../../../configs/endpoints';
import { getDeviceToken } from '../../../services/authService';

export const registerUser = (userDetails) =>
    fetchApi({
        method: 'POST',
        url: endpoints.register,
        data: userDetails
    });

export const getRegisterInstructor = (params) =>
    fetchApi({
        method: 'GET',
        url: endpoints.registerInstructors,
        params: params
    });

// Attaches this device's trust token (if it has one) so the backend can skip 2FA when it's
// still valid — see backend tokenService.TRUSTED_DEVICE_EXPIRATION_DAYS.
export const loginUser = (loginDetails) =>
    fetchApi({
        method: 'POST',
        url: endpoints.login,
        data: { ...loginDetails, deviceToken: getDeviceToken(loginDetails.email) }
    });

// Second step of login when this device isn't (or is no longer) trusted — submits the emailed
// code, not the password again.
export const verifyLoginTwoFactor = (payload) =>
    fetchApi({
        method: 'POST',
        url: endpoints.verifyLoginTwoFactor,
        data: payload
    });

// Revokes the refresh token server-side. Without this, logging out only cleared the local
// cookies — the refresh token (valid 30 days) stayed fully valid in the database, so anyone
// who had captured it beforehand (XSS, shared machine) could keep minting fresh access tokens
// long after the user believed they'd logged out.
export const logoutUser = (refreshToken) =>
    fetchApi({
        method: 'POST',
        url: endpoints.logout,
        data: { refreshToken }
    });

export const verifyEmail = (params) =>
    fetchApi({
        method: 'POST',
        url: endpoints.verifyEmail,
        params
    });

export const forgotPassword = (emailDetails) =>
    fetchApi({
        method: 'POST',
        url: endpoints.forgotPassword,
        data: emailDetails
    });

export const resetPassword = (token, newPasswordDetails) =>
    fetchApi({
        method: 'POST',
        url: endpoints.resetPassword,
        params: { token },
        data: newPasswordDetails
    });